<template>
  <v-row>
    <v-col xs-12>
    <v-card class="mb-2">
        <v-toolbar flat color="secondary" dark>
            <v-icon left>mdi-format-list-bulleted</v-icon>
            <v-toolbar-title>Handling List</v-toolbar-title>
        </v-toolbar>
        <v-data-table
            :items="handlings"
            :headers="headers"
        >
            <template #[`item.items`]="{item}">
                {{item.items.length}}
            </template>
            <template #[`item.actions`]="{item}">
                <v-btn icon @click="$router.push('/build/handling/'+item.id)">
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
            </template>

        </v-data-table>
    </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props:{
        build:{
            type: Object,
            required:true
        }
    },
    data: () => ({
        handlings:[],
        headers:[
            {text:'Id',value:'id'},
            {text:'Status',value:'status_id'},
            {text:'Items', value:'items'},
            {text:'Action', value:'actions'}
        ]
    }),
    mounted(){
        this.init();
    },
    methods:{
        ...mapActions("build",{getHandlingList: "getHandlingList"}),
        init(){
            this.getHandlingList(this.build.id)
            .then(({handlings}) => {
                this.handlings = handlings
            })
        }
    }
}
</script>

<style>

</style>